import type {
  IAdapterConfig,
  MiddlewareConfigClass
} from '@care-portals/api-interfaces';

const config = {
  bondRx: {
    label: 'BondRx',
    functions: {
      CreateOrder: {
        middlewareHandler: 'bond-rx',
        version: 2,
        label: 'Create BondRx order',
        pipelines: ['order'],
        passPayload: true,
        params: []
      },
      HandleWebhook: {
        middlewareHandler: 'bond-rx',
        version: 2,
        label: 'Handle BondRx webhook',
        pipelines: ['webhook'],
        passPayload: true,
        params: []
      },
      CancelOrder: {
        middlewareHandler: 'bond-rx',
        version: 2,
        label: 'Cancel BondRx order',
        pipelines: ['order', 'webhook', 'prescription'],
        params: [{ key: 'orderId', label: 'Bond Order Id', type: 'string' }],
        passPayload: true
      }
    }
  }
} as const;

export const BondRxConfig: IAdapterConfig = {
  ...config
} as unknown as IAdapterConfig;

export type BondRxFunctionConfiguration = MiddlewareConfigClass<
  typeof config.bondRx.functions
>;
